// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/stylesheets/lighter-youtube.css
// module id = 8
// module chunks = 0